import dictionary from './ru-RU'

function each (messages: Record<string, any>, path: string[] = []): Record<string, any> {
  const o: Record<string, any> = {}
  Object.keys(messages).forEach((key) => {
    if (typeof messages[key] === 'string') {
      o[key] = path.length ? `${path.join('.')}.${key}` : key
    } else if (messages[key]) {
      o[key] = each(messages[key], [...path, key])
    }
  })
  return o
}

export default each(dictionary)
